class AstroHeader {
  constructor() {
    this.header = document.querySelector('[data-header]');
    this.menuToggle = document.querySelector('[data-menu-toggle]');
    this.mobileNav = document.querySelector('[data-mobile-nav]');
    this.searchToggle = document.querySelector('[data-search-toggle]');
    this.searchPanel = document.querySelector('[data-search-panel]');

    this.init();
  }

  init() {
    if (this.menuToggle && this.mobileNav) {
      this.menuToggle.addEventListener('click', () => this.toggleMenu());
    }

    if (this.searchToggle && this.searchPanel) {
      this.searchToggle.addEventListener('click', () => this.toggleSearch());
    }

    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
  }

  toggleMenu() {
    const isOpen = this.mobileNav.classList.toggle('is-open');
    this.menuToggle.setAttribute('aria-expanded', isOpen);
    document.body.classList.toggle('menu-open', isOpen);
  }

  toggleSearch() {
    const isOpen = this.searchPanel.classList.toggle('is-open');
    this.searchToggle.setAttribute('aria-expanded', isOpen);
    if (isOpen) {
      this.searchPanel.querySelector('input')?.focus();
    }
  }

  handleScroll() {
    if (!this.header) return;
    this.header.classList.toggle('is-scrolled', window.scrollY > 20);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AstroHeader();

  document.querySelectorAll('[data-availability-toggle]').forEach((input) => {
    input.addEventListener('change', () => {
      const addUrl = input.dataset.urlAdd || '';
      const removeUrl = input.dataset.urlRemove || '';
      // Only trust Shopify helper URLs that clearly target in-stock (availability=1).
      if (input.checked && addUrl.includes('filter.v.availability=1')) {
        window.location.href = addUrl;
        return;
      }
      if (!input.checked && removeUrl) {
        window.location.href = removeUrl;
        return;
      }

      const url = new URL(window.location.href);
      if (input.checked) {
        url.searchParams.set('filter.v.availability', '1');
      } else {
        url.searchParams.delete('filter.v.availability');
      }
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-collection-filters]').forEach((form) => {
    form.querySelectorAll('[data-filter-auto]').forEach((input) => {
      input.addEventListener('change', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', (e) => {
      const form = e.target.closest('form');
      const addBtn = form?.querySelector('[name="add"]');
      const option = e.target.selectedOptions[0];
      const available = option?.dataset.available === 'true';

      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available
          ? addBtn.dataset.labelAdd
          : addBtn.dataset.labelSoldOut;
      }
    });
  });
});
